<div class="header-wrapper">
    
    <img 
        class="logo" 
        [ngSrc]="gslogo" 
        [alt]="'logo'" 
        width="146" 
        height="146" 
        loading="eager"
    >
    <div class="icon">
        <span [style.color]="gscolor">AI</span>
    </div>
</div>